import { ServiceBase } from '../../../../../core/services/ServiceBase'
import CategoryProxy from './CategoryProxy'

class CategoryService extends ServiceBase {
  postCategoryContactUs(params) {
    return this.getData(() => CategoryProxy.postCategoryContactUs(params))
  }
}

export default new CategoryService()
